module.exports = __webpack_public_path__ + "static/media/razorPay_img.fcfab237.png";